<template>
  <div class="page-container">
    <Sidebar />
    <div class="main-content">
      <AdminTable :apiEndpoint="'/api/admin/query-logs'" :columns="columns" :filters="filters" :formFields="formFields" title="查询日志" />
    </div>
  </div>
</template>
<script>
import Sidebar from '../components/Sidebar.vue'
import AdminTable from '@/components/AdminTable.vue'
export default { name: 'QueryLogsList', components: { Sidebar, AdminTable },
  data() { return {
    columns: [{ key: 'id', label: 'ID' }, { key: 'user_id', label: '用户ID' }, { key: 'query_type', label: '类型' }, { key: 'query_content', label: '内容' }, { key: 'created_at', label: '时间', type: 'date' }],
    filters: [], formFields: []
  } }
}
</script>
<style scoped>
.page-container { display: flex; min-height: 100vh; background: #f5f5f5; }
.main-content { flex: 1; margin-left: 260px; padding: 30px; }
</style>
